import { MaxWidthProps } from 'styled-system';

export { Theme } from '../../../config/config.types';
export const DEFAULT_MAX_WIDTH = 1440;

type HTMLElementType = any;

export type StyledProps = MaxWidthProps & {};

export interface ComponentProps extends HTMLElementType, StyledProps {
  maxWidth?: string | number;
}
